import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Button, Modal, Spin, Row, UploadFile } from 'antd';
import { queries } from '../../../graphql/graphql';
import { IPlan } from '../../../types/plans';
import { FileGrid } from '../../Form/FileGrid';

interface FindPhotosProps {
  plan?: IPlan;
  onChange?: (value: UploadFile[]) => void;
  value?: UploadFile[];
}

export const FindPhotos = ({ plan, onChange, value = [] }: FindPhotosProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    data = {},
    loading,
    refetch,
  } = useQuery(queries.FIND_PHOTOS, {
    variables: {
      decorId: plan?.decorId,
      id: plan?.id,
    },
    skip: !plan,
  });
  const { findPhotos } = data;

  if (!plan) return null;

  const showModal = () => {
    refetch();
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onAdd = (file: UploadFile) => {
    const newList = [...value];
    newList.push({
      ...file,
      url: file.original || file.url,
    });
    onChange?.(newList);
  };

  const getPhotoAction = (file: UploadFile) => {
    const actions = [
      <Button style={{ width: '100%' }} type="primary" onClick={() => onAdd(file)} key="preview">
        Add
      </Button>,
    ];

    return actions;
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        Find Photos
      </Button>
      <Modal width="90%" title="Photos" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        {loading ? (
          <Spin />
        ) : (
          <Row gutter={[16, 16]}>
            {findPhotos && findPhotos.photos && findPhotos.photos.length && (
              <FileGrid fileList={findPhotos.photos} getActions={getPhotoAction} />
            )}
          </Row>
        )}
      </Modal>
    </>
  );
};
